import { Router } from '@angular/router';
import { NavigationParams } from 'src/app/models/navigation/navigationParams.interface';
import { IRoutesQueryParamsFactory } from './routeQueryParamsFactory.inteface';

export class RoutesQueryParamsFactory implements IRoutesQueryParamsFactory {
  constructor(private readonly _router: Router) {}

  public create(foundParams: NavigationParams): NavigationParams | undefined {
    if (this._router.url.includes('integrations')) {
      return this._integrationsQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('violations')) {
      return this._violationsQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('inventory')) {
      return this._inventoryQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('hygiene')) {
      return this._hygieneQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('policies')) {
      return this._policyQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('ai-activity')) {
      // New individual AI activity route
      return this._agentStepQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('ai-findings')) {
      // New individual AI findings route
      return this._findingQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('ai-prevention')) {
      // New individual AI prevention route
      return this._preventionQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('ai-in-line-control')) {
      // New individual AI in-line control route
      return this._inLineControlQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('issues')) {
      return this._issuesQueryParamsCreation(foundParams);
    } else if (this._router.url.includes('data-lens')) {
      return this._dataLensQueryParamsCreation(foundParams);
    }

    return undefined;
  }

  private _findingQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    const foundParamsLength = Object.keys(foundParams).length;
    const isFindingParam = foundParams.integration && foundParamsLength == 2 && foundParams.finding;
    const isFindingThreadParam =
      foundParams.integration &&
      foundParamsLength == 4 &&
      foundParams.agentStep &&
      foundParams.stepThreadId &&
      foundParams.finding;
    const isThreadFindingsParam = foundParamsLength == 1 && foundParams.findingThreadId;

    return isFindingParam || isFindingThreadParam || isThreadFindingsParam ? foundParams : undefined;
  }

  private _preventionQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 2 && foundParams.preventionId) {
      return { showPrevention: true };
    }

    return undefined;
  }

  private _agentStepQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    const keys = Object.keys(foundParams);
    const hasInline = (foundParams as Record<string, unknown>)['inline'] !== undefined;
    if (
      foundParams.integration &&
      (keys.length == 3 || (keys.length == 4 && hasInline)) &&
      foundParams.agentStep &&
      foundParams.stepThreadId
    ) {
      return foundParams;
    }

    return undefined;
  }

  private _inLineControlQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    const keys = Object.keys(foundParams);
    const hasInline = (foundParams as Record<string, unknown>)['inline'] !== undefined;
    if (foundParams.integration && (keys.length == 2 || (keys.length == 3 && hasInline)) && foundParams.inLineControl) {
      return foundParams;
    }

    return undefined;
  }

  private _integrationsQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 1) {
      return foundParams;
    }

    return undefined;
  }

  private _policyQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length == 1) {
      return foundParams;
    }
    return undefined;
  }

  private _violationsQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (
      foundParams.integration &&
      Object.keys(foundParams).length == 2 &&
      (foundParams.violation || foundParams.resource)
    ) {
      return foundParams;
    }

    return undefined;
  }

  private _hygieneQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (
      foundParams.integration &&
      Object.keys(foundParams).length == 2 &&
      (foundParams.violation || foundParams.resource)
    ) {
      return foundParams;
    }

    return undefined;
  }

  private _issuesQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    const foundParamsLength = Object.keys(foundParams).length;
    const isIssueParam = foundParams.integration && foundParamsLength == 2 && foundParams.issue;
    const isIssueWithFindingParam =
      foundParams.integration && foundParamsLength == 3 && foundParams.issue && foundParams.finding;
    const isIssueWithViolationParam =
      foundParams.integration && foundParamsLength == 3 && foundParams.issue && foundParams.violation;
    return isIssueParam || isIssueWithFindingParam || isIssueWithViolationParam ? foundParams : undefined;
  }

  private _inventoryQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (
      foundParams.integration &&
      Object.keys(foundParams).length == 2 &&
      (foundParams.violation || foundParams.resource)
    ) {
      return foundParams;
    }

    return undefined;
  }

  private _dataLensQueryParamsCreation(foundParams: NavigationParams): NavigationParams | undefined {
    if (foundParams.integration && Object.keys(foundParams).length === 2 && foundParams.dataItem) {
      return foundParams;
    }

    return undefined;
  }
}
